// Mock data for Shri Kothari Jewellers landing page

export const businessInfo = {
  name: "Shri Kothari Jewellers",
  tagline: "Exquisite Silver Craftsmanship Since 1987",
  heritage: "39 Years",
  description: "For nearly four decades, Shri Kothari Jewellers has been Indore's trusted destination for premium silver articles, idols, utensils, and bespoke gifting solutions. Our commitment to quality and craftsmanship makes every piece a timeless treasure.",
  address: "Shop No. 206, 2nd Floor, Balaji Complex, 68, above Nakoda Hallmarking, Bada Sarafa, Sarafa Bazar, Indore, Madhya Pradesh 452002",
  phone: "+91 9893254712",
  email: "shrikotharijewellersindore@gmail.com",
  hours: {
    weekdays: "11:30 AM - 8:30 PM",
    days: "Monday to Saturday",
    closed: ""
  },
  googleMapsUrl: "https://www.google.com/maps/place/Shri+Kothari+Jewellers/@22.7186595,75.850008,765m/data=!3m1!1e3!4m10!1m2!2m1!1sshri+kothari+jewellers+indore+photos!3m6!1s0x3962fda9fadfc023:0xcca0f768abc3df72!8m2!3d22.718065!4d75.852586!15sCiRzaHJpIGtvdGhhcmkgamV3ZWxsZXJzIGluZG9yZSBwaG90b3NaJiIkc2hyaSBrb3RoYXJpIGpld2VsbGVycyBpbmRvcmUgcGhvdG9zkgEHamV3ZWxlcuABAA!16s%2Fg%2F11j8t2znjg",
  instagramUrl: "https://www.instagram.com/shrikotharijewellers/",
  whatsappNumber: "919893254712"
};

export const categories = [
{
  id: 1,
  name: "Silver Idols",
  description: "Sacred silver idols of deities, crafted with devotion and precision",
  image: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/xsnp09ir_IMG_3299.jpg",
  icon: "Sparkles"
},
{
  id: 2,
  name: "Silver Utensils",
  description: "Premium silver utensils for your dining elegance",
  image: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/6burykaq_IMG_3300.jpg",
  icon: "Utensils"
},
{
  id: 3,
  name: "Gifting Articles",
  description: "Exquisite silver gift items for every special occasion",
  image: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/j6he2nhc_IMG_3305.jpg",
  icon: "Gift"
},
{
  id: 4,
  name: "Silver Jewelry",
  description: "Elegant bangles, bracelets, rings and chains with premium craftsmanship",
  image: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/9n65eu49_IMG_3304.jpg",
  icon: "Wine"
},
{
  id: 5,
  name: "Puja Accesories",
  description: "Beautiful silver decorative pieces for your home",
  image: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/uuo6uz97_IMG_3307.jpg",
  icon: "Coins"
},
{
  id: 6,
  name: "Silver Accessories",
  description: "Unique silver accessories including footwear and lifestyle items",
  image: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/k3qs0dzt_IMG_3306.jpg",
  icon: "Coffee"
}];


export const galleryImages = [
{
  id: 1,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/xsnp09ir_IMG_3299.jpg",
  title: "Divine Silver Idols Collection",
  category: "Idols"
},
{
  id: 2,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/6burykaq_IMG_3300.jpg",
  title: "Premium Silver Water Set",
  category: "Utensils"
},
{
  id: 3,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/1adtdys2_IMG_3301.jpg",
  title: "Ornate Silver Containers",
  category: "Gifts"
},
{
  id: 4,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/n252z1uc_IMG_3302.jpg",
  title: "Decorative Silver Bottles",
  category: "Decorative"
},
{
  id: 5,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/xoyhhfj7_IMG_3303.jpg",
  title: "Exquisite Silver Rings",
  category: "Jewelry"
},
{
  id: 6,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/9n65eu49_IMG_3304.jpg",
  title: "Designer Silver Bangles",
  category: "Jewelry"
},
{
  id: 7,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/j6he2nhc_IMG_3305.jpg",
  title: "Ornate Silver Clutch",
  category: "Gifts"
},
{
  id: 8,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/k3qs0dzt_IMG_3306.jpg",
  title: "Silver Decorative Footwear",
  category: "Accessories"
},
{
  id: 9,
  url: "https://customer-assets.emergentagent.com/job_kothari-jewels/artifacts/uuo6uz97_IMG_3307.jpg",
  title: "Traditional Silver Diya",
  category: "Decorative"
}];


export const testimonials = [
{
  id: 1,
  name: "Priya Sharma",
  text: "Purchased a beautiful silver Lakshmi idol for Diwali. The craftsmanship is exceptional!",
  rating: 5
},
{
  id: 2,
  name: "Rajesh Patel",
  text: "Best place in Indore for silver utensils. Quality is unmatched and staff is very helpful.",
  rating: 5
},
{
  id: 3,
  name: "Anjali Verma",
  text: "Got customized mugs for my wedding return gifts. Everyone loved them!",
  rating: 5
}];


export const features = [
{
  icon: "Shield",
  title: "Genuine Silver",
  description: "100% pure silver with hallmark certification"
},
{
  icon: "Award",
  title: "39+ Years Legacy",
  description: "Nearly four decades of trust and excellence"
},
{
  icon: "Palette",
  title: "Custom Designs",
  description: "Personalized creations for your special moments"
},
{
  icon: "Heart",
  title: "Quality Assured",
  description: "Every piece crafted with precision and care"
}];